import * as React from 'react';
export const CopiedIcon = React.memo(function CopiedIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
      <path d="M10.4294 0.844401L5.09037 6.10641L2.57545 3.63523C2.13519 3.2026 1.44064 3.17142 0.962168 3.5434L0.855801 3.63641C0.3814 4.10388 0.3814 4.86001 0.855801 5.32748L5.09011 9.5L12.1422 2.55079C12.6181 2.08192 12.6194 1.32396 12.1453 0.853437C11.674 0.38574 10.9058 0.381694 10.4294 0.844401Z" fill="white" />
    </svg>;
});